<template>
  <halo-dialog direction="bottom" :visible="visible" @cancel="cancel">
    <div class="hall-dialog" :class="screen" v-if="visible">
      <div class="close-header" @click="cancel">
        <img src="../images/close_icon.png" class="close-icon" />
      </div>
      <div class="hall-content">
        <hotel-banner :data="attach" />
        <div class="info-wrap one-px-bottom">
          <div class="title-wrap">
            <div class="title">
              {{ data.name }}
            </div>
            <div class="tag" v-if="typeText">#{{ typeText }}</div>
          </div>
          <div class="desc" v-if="data.profile">{{ data.profile }}</div>
        </div>
        <div class="infos" v-if="cate === 1">
          <div class="flex">
            <div class="info-item">
              <img class="icon" src="https://img1.halobear.com/wedding/FtFnc2f3tsvaWndNJ46ipMkoHxbV.png" />
              <div class="label">场地面积：</div>
              <div class="value">
                {{ data.hall_area != 0 ? `${data.hall_area}㎡` : '-' }}
              </div>
            </div>
            <div class="info-item">
              <img class="icon" src="https://img1.halobear.com/wedding/FhVZpIGpBMmDX2DoE2kcvbRz8uAg.png" />
              <div class="label">容纳人数：</div>
              <div class="value">
                {{ data.galleryful ? `${data.galleryful}人` : '-' }}
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="info-item">
              <img class="icon" src="https://img1.halobear.com/wedding/FqDvU_V9NWERkS0AATkGj6E-O1az.png" />
              <div class="label">无线网络：</div>
              <div class="value">
                <span>
                  {{ data.has_wifi || '-' }}
                </span>
              </div>
            </div>
            <div class="info-item">
              <img class="icon" src="https://img1.halobear.com/wedding/Flk6aiHrnOM5Ttt6pCp45tTdHxdV.png" />
              <div class="label">独立化妆间：</div>
              <div class="value">
                <span>
                  {{ data.has_exclusive_ladies_room || '-' }}
                </span>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="info-item">
              <img class="icon" src="https://img1.halobear.com/wedding/FlgJ-XtZA0Or76qsl3XCRd5dMsp7.png" />
              <div class="label">场地视野：</div>
              <div class="value">{{ data.field_vision || '-' }}</div>
            </div>
          </div>
          <div class="flex">
            <div class="info-item">
              <img src="https://img1.halobear.com/wedding/FtxfIR8CHCgCBq0kLUHDMZONVWJM.png" class="icon" />
              <div class="label">场地风景：</div>
              <div class="value">{{ data.scenery || '-' }}</div>
            </div>
          </div>
          <div class="flex">
            <div class="info-item">
              <img src="https://img1.halobear.com/wedding/Fq6vY7qy-WU6ber9k53aaDbLL8pX.png" class="icon" />
              <div class="label">场地私密性：</div>
              <div class="value">{{ data.privacy || '-' }}</div>
            </div>
          </div>
        </div>
        <div class="infos" v-else-if="cate === 2">
          <div class="flex">
            <div class="info-item">
              <img class="icon" src="https://img1.halobear.com/wedding/FtFnc2f3tsvaWndNJ46ipMkoHxbV.png" />
              <div class="label">场地面积：</div>
              <div class="value">
                {{ data.hall_area != 0 ? `${data.hall_area}㎡` : '-' }}
              </div>
            </div>
            <div class="info-item">
              <img class="icon" src="https://img1.halobear.com/wedding/FhVZpIGpBMmDX2DoE2kcvbRz8uAg.png" />
              <div class="label">容纳人数：</div>
              <div class="value">
                {{ data.galleryful ? `${data.galleryful}人` : '-' }}
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="info-item">
              <img class="icon" src="https://img1.halobear.com/wedding/FhwDl0fONbGruqwDii01ER9v_Z_D.png" />
              <div class="label">立柱数量：</div>
              <div class="value">
                {{ data.pillar_num ? `${data.pillar_num}个` : '无' }}
              </div>
            </div>
            <div class="info-item">
              <img class="icon" src="https://img1.halobear.com/wedding/Fkrev9UDz6CnapNVEdOPXCWRaoYe.png" />
              <div class="label">起订桌数：</div>
              <div class="value">
                {{ data.min_order_table_num ? `${data.min_order_table_num}桌` : '-' }}
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="info-item">
              <img class="icon" src="https://img1.halobear.com/wedding/Fkrev9UDz6CnapNVEdOPXCWRaoYe.png" />
              <div class="label">最大桌数：</div>
              <div class="value">
                {{ data.table_num ? `${data.table_num}桌` : '-' }}
              </div>
            </div>
            <div class="info-item">
              <img class="icon" src="https://img1.halobear.com/wedding/Fkrev9UDz6CnapNVEdOPXCWRaoYe.png" />
              <div class="label">最佳桌数：</div>
              <div class="value">
                {{ data.optimal_table_num ? `${data.optimal_table_num}桌` : '-' }}
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="info-item">
              <img class="icon" src="https://img1.halobear.com/wedding/FqDvU_V9NWERkS0AATkGj6E-O1az.png" />
              <div class="label">无线网络：</div>
              <div class="value">
                <span>
                  {{ data.has_wifi || '-' }}
                </span>
              </div>
            </div>
            <div class="info-item">
              <img class="icon" src="https://img1.halobear.com/wedding/Flk6aiHrnOM5Ttt6pCp45tTdHxdV.png" />
              <div class="label">独立化妆间：</div>
              <div class="value">
                <span>
                  {{ data.has_exclusive_ladies_room || '-' }}
                </span>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="info-item">
              <img class="icon" src="https://img1.halobear.com/wedding/FnaK2_XuIBWZIzo6cIEcOrl0FMN3.png" />
              <div class="label">宴会厅楼层：</div>
              <div class="value">
                {{ data.floor_num || '-' }}
              </div>
            </div>
            <div class="info-item">
              <img class="icon" src="https://img1.halobear.com/wedding/FvQ6J9jcuYyYSXnA0yTEIDtv6rXO.png" />
              <div class="label">宴会厅形状：</div>
              <div class="value">
                {{ data.shape || '-' }}
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="info-item">
              <img class="icon" src="https://img1.halobear.com/wedding/FlgJ-XtZA0Or76qsl3XCRd5dMsp7.png" />
              <div class="label">场地视野：</div>
              <div class="value">{{ data.field_vision || '-' }}</div>
            </div>
          </div>
          <div class="flex">
            <div class="info-item">
              <img src="https://img1.halobear.com/wedding/FtxfIR8CHCgCBq0kLUHDMZONVWJM.png" class="icon" />
              <div class="label">场地风景：</div>
              <div class="value">{{ data.scenery || '-' }}</div>
            </div>
          </div>
          <div class="flex">
            <div class="info-item">
              <img src="https://img1.halobear.com/wedding/Fq6vY7qy-WU6ber9k53aaDbLL8pX.png" class="icon" />
              <div class="label">场地私密性：</div>
              <div class="value">{{ data.privacy || '-' }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </halo-dialog>
</template>

<script>
import qs from '@halobear/utils/qs'
import HaloDialog from '@/components/halo-dialog'

import HotelBanner from './hotel-banner'

export default {
  components: {
    HaloDialog,
    HotelBanner,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    cate: {
      type: Number,
      default: 0,
    },
    screen: {
      type: String,
      default: 'vertical',
    },
  },
  computed: {
    typeText() {
      const { type } = this.data
      const types = {
        1: '外景',
        2: '大堂',
        3: '迎宾区',
        4: '宴会厅',
        5: '户外场地',
        6: '房间',
        7: '泳池',
        8: '沙滩',
        9: '教堂',
        10: '草坪',
        11: '水台',
        12: '婚房',
      }
      return types[type]
    },
    attach() {
      const route = this.$route
      // 兼容App内部全景
      const query = route.query.hall_id ? route.query : qs.parse(window.location.search.split('?')[1] || '')
      const { attach = [] } = this.data
      return query.phone ? attach.slice(0, 1) : attach
    },
  },
  emits: ['cancel'],
  methods: {
    cancel() {
      this.$emit('cancel', false)
    },
  },
}
</script>

<style lang="less" scoped>
.hall-dialog {
  width: 100vw;
  max-height: 92vh;
  background: #ffffff;
  border-radius: 20px 20px 0px 0px;
  display: flex;
  flex-direction: column;
  // 横屏
  &.landscape {
    max-height: 92vh;
    .header-wrap {
      height: 36px;
    }
    .close-header {
      height: 36px;
    }
  }
  .close-header {
    flex-shrink: 0;
    height: 72px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    cursor: pointer;
  }
  .close-icon {
    width: 54px;
    height: 24px;
  }
}

.hall-content {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    display: none;
  }
  .title-wrap {
    display: flex;
    justify-content: space-between;
  }
  .info-wrap {
    margin: 40px 40px 0;
    padding-bottom: 16px;
  }
  .title {
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 34px;
  }
  .tag {
    height: 36px;
    background: #efefef;
    padding: 0 0.4em;
    font-size: 24px;
  }
  .desc {
    color: #68676c;
    font-size: 26px;
    padding: 6px 0 40px;
  }
  .infos {
    padding: 0 40px 40px;
  }
  .info-item {
    display: flex;
    align-items: center;
    font-size: 26px;
    flex: 1;
    height: 60px;
    .icon {
      width: 30px;
      height: 30px;
      margin: 16px;
    }
    .label {
      color: #95949d;
    }
  }
}
</style>
